import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._onGlobalClick = this._onGlobalClick.bind(this)
    document.addEventListener("click", this._onGlobalClick)
  }

  disconnect() {
    document.removeEventListener("click", this._onGlobalClick)
  }

  _onGlobalClick(event) {
    const trigger = event.target.closest('[data-bs-toggle="tab"]') || event.target.closest('[data-tab-toggle]')
    if (!trigger) return

    event.preventDefault()
    this.activate(trigger)
  }

  activate(trigger) {
    const targetSelector = trigger.getAttribute("data-bs-target") || trigger.getAttribute("data-tab-target") || trigger.getAttribute("href")
    if (!targetSelector) return

    const targetPane = document.querySelector(targetSelector)
    if (!targetPane) return

    const tabList = trigger.closest('.nav, [role="tablist"]')
    if (tabList) {
      tabList.querySelectorAll('[data-bs-toggle="tab"], [data-tab-toggle]').forEach((tabButton) => {
        tabButton.classList.remove("active")
        tabButton.setAttribute("aria-selected", "false")
      })
    }

    trigger.classList.add("active")
    trigger.setAttribute("aria-selected", "true")

    const container = targetPane.parentElement
    if (container) {
      Array.from(container.children).forEach((pane) => {
        if (pane.classList.contains("tab-pane")) {
          pane.classList.remove("active", "show")
        }
      })
    }

    targetPane.classList.add("active", "show")

    this._dispatch(trigger, "shown.bs.tab")
    this._dispatch(trigger, "tab:shown")
  }

  _dispatch(element, type) {
    const event = new CustomEvent(type, { bubbles: true, cancelable: true })
    element.dispatchEvent(event)
    return event
  }
}
